<template v-if="this.$keycloak">
  <div v-if="hasAccess">
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  computed: {
    hasAccess() {
      const roles = this.$keycloak.tokenParsed.realm_access.roles;
      if (roles.includes('level_1')) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SuperAdmin.vue